<template>
  <div class="page" @touchmove.prevent>
    <div class="bg-window"></div>
    <div class="main">

      <div class="declaration">
        <img class="pic-declaration" src="https://static.huiyiji520.com/cppic-1661919742.png">
      </div>

      <div class="btn agree flex-box" @click="chooseSurprise('agree')" :style="{color: getBtnColor('agree'), backgroundColor: getBtnBackground('agree')}">
        <div class="btn-title">愿意</div>
        <div class="btn-hint">
          <img v-if="surprise != 'agree'" class="pic-btn-hint" src="https://static.huiyiji520.com/cppic-1661919783.png">
          <img v-if="surprise == 'agree'" class="pic-btn-hint" src="https://static.huiyiji520.com/cppic-1661919766.png">
        </div>
      </div>

      <div class="btn disagree flex-box" @click="chooseSurprise('disagree')" :style="{color: getBtnColor('disagree'), backgroundColor: getBtnBackground('disagree')}">不愿意</div>

      <!-- <div class="refund">
        <img class="pic-refund" src="https://static.huiyiji520.com/cppic-1661919725.png">
      </div> -->

      <div class="arrows">
        <div class="signs flex-box">
          <!-- <div class="prev" @click="goBack()"><van-icon name="arrow-left" color="#eb8e80" />上一步</div>
          <div class="next" @click="goNext()">下一步<van-icon name="arrow" color="#eb8e80" /></div> -->
          <img class="pic-prev" @click="goBack()" src="https://static.huiyiji520.com/cppic-1661159773.png">
          <img class="pic-next" @click="goNext()" src="https://static.huiyiji520.com/cppic-1661157292.png">
        </div>
      </div>

    </div>
  </div>
</template>

<script>
// import wx from 'weixin-js-sdk'
import { Toast} from 'vant'

export default{
  components: {
    [Toast.name]: Toast
  },
  data(){
    return {
      surprise: ''
    }
  },
  methods: {
    handleRouter(path){
      this.$router.push(path)
    },
    goBack(){
      this.$router.back()
    },
    goNext(){
      if(!this.surprise){
        Toast('请选择是否愿意')
      }else{
        let cpchoose = this.$store.state.cpchoose
        cpchoose.partnerSurprise = this.surprise
        this.$store.commit('updateCpChoose', cpchoose)
        this.handleRouter('/entry_submit')
      }
    },
    chooseSurprise(surprise){
      this.surprise = surprise
    },
    getBtnColor(surprise){
      return this.surprise == surprise ? '#fff' : '#737373'
    },
    getBtnBackground(surprise){
      return this.surprise == surprise ? '#f1b8af' : '#fff'
    },
    recoverSurprise(){
      this.surprise = this.$store.state.cpchoose.partnerSurprise ? this.$store.state.cpchoose.partnerSurprise : this.surprise
    }
  },
  mounted(){
    this.recoverSurprise()
    this.$report.submit('/choose_partner_surprise', this.$store.state.issue, this.$store.state.userinfo.openid)
  }
}
</script>

<style scoped>
.page{min-height:100vh;}
.bg-window{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-image: url("https://static.huiyiji520.com/cppic-1661178636.png");
  background-size:100% 100%;
  background-repeat:no-repeat;
  /* opacity:0.1; */
  z-index:-1;
}
.main{text-align:center;}
.main .declaration{width:82%;background:#fff;margin:0 auto;margin-top:103px;padding:90px 0px;}
.main .declaration .pic-declaration{width:512px;height:433px;margin:0 auto;}
/* .main .btn{width:435px;margin:0 auto;font-size:32px;border:4px solid #f1b8af;border-radius:20px;} */
.main .btn{width:435px;margin:0 auto;font-size:32px;border:3px solid #f1b8af;}
/* .main .btn .btn-hint{font-size:14px;margin-top:15px;transform: scale(1);} */
/* .main .btn .btn-hint{font-size:18px;margin-top:15px;padding:0px 20px;} */
.main .btn .pic-btn-hint{width:266px;height:41px;margin-top:17px;}
.main .btn.agree{height:153px;margin-top:69px;flex-direction:column;justify-content:center;border-radius:20px;}
.main .btn.disagree{height:66px;margin-top:52px;margin-bottom:59px;justify-content:center;border-radius:15px;}
.main .refund .pic-refund{width:373px;height:54px;margin:0 auto;}
.main .arrows{position: fixed;bottom:100px;width:100%;}
.main .arrows .signs{
  justify-content:space-between;padding:0px 194px;
  font-size:32px;color:#eb8e80;
}
.main .pic-prev{width:120px;height:32px;}
.main .pic-next{width:120px;height:32px;}
</style>
